import router from "@/router"
import httpRequest from "@/services/httpRequest"

export default ({
  namespaced: true,
  state: {
    error: null,
    auth: null,
    isNotified: false
  },
  mutations: {
    SET_AUTH(state, data) {
      state.auth = data
    },
    SET_ERROR(state, data) {
      state.error = data
    }
  },
  actions: {
    async changePassword({ rootState, commit }, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api-auth/password/change`,
          method: 'POST',
          data: data
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        rootState.showPopUpModal = true
        rootState.isLoading = false
      } else {
        let errors;
        for (const field in res.data) {
          errors = res.data[field][0];
        }
        commit('SET_ERROR', errors)
        rootState.isLoading = false
      }
    },

    async changeProfile({ rootState, state }, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/profile/update`,
          method: 'PUT',
          data: data
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        rootState.showPopUpModal = true
        rootState.isLoading = false
      } else {
        state.error = res.data
        rootState.isLoading = false
      }
    },

    async getAuth({ rootState, state, commit }) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api-auth/user`,
          method: 'GET'
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        commit('SET_AUTH', res.data)
      }
    },

    async changeAuth({ rootState, state }, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api-auth/user`,
          method: 'PUT',
          data: data
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        rootState.showPopUpModal = true
        rootState.isLoading = false
      } else {
        state.error = res.data
        rootState.isLoading = false
      }
    },

    async registerDeviceNotification({rootState}, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/gcmdevice`,
          method: 'POST',
          data: data
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        return true
      } else {
        return false
      }
    },

    async unregisterDeviceNotification({rootState}, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/gcmdevice/unregister`,
          method: 'POST',
          data: data
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        return true
      } else {
        return false
      }
    }
  }
})